import { FC } from 'react';
import Image from 'frontastic/lib/image';
import { CLEAN_FLUSH } from 'helpers/constants/attributes';
import { CLEANFLUSH_BADGES } from 'helpers/constants/badges';

export const isCleanFlushEnabled = (productspec?: Record<string, unknown>): boolean => {
  const value = productspec?.[CLEAN_FLUSH];
  return value === true || value === 'Yes';
};

type CleanFlushIconsProps = {
  className?: string;
};

const CleanFlushIcons: FC<CleanFlushIconsProps> = ({ className = '' }) => (
  <div className={`flex flex-wrap items-center gap-24 lg:gap-32 ${className}`}>
    {CLEANFLUSH_BADGES.map((badge, index) => (
      <Image
        key={badge}
        src={badge}
        alt={`CleanFlush badge ${index + 1}`}
        width={800}
        height={815}
        className="h-80 w-auto lg:h-100"
      />
    ))}
  </div>
);

export default CleanFlushIcons;